// @flow
import React, { Component } from 'react'
import i18n from 'live/services/i18n'

import { HelpBlock } from 'react-bootstrap'
import Modal from 'live/components/ui/Modal'
import SaveButton from 'live/components/forms/ui/button-save'
import xhr from 'live/services/xhr'
import { StyledRichText } from 'plugin-liverig/shared/asset/styled'
import { FieldRow, InputContainer } from 'plugin-liverig/shared/asset/components/Fieldset'
import { useFormState } from 'react-use-form-state'
import _ from 'lodash'

const SITOP_COMMENT_URL = '/sitop_comments/'
const URL = '/services/plugin-petrobras'

type Props = {
    event: { [string]: * },
    onHide: Function,
    liftSubmitFn?: Function,
}

type State = {
    submitted: boolean,
    form: Object,
}

export default class SitopComment extends Component<Props, State> {

    static defaultProps = {
        submitted: false
    }

    constructor (props: Props) {
        super(props)
        this.props = props

        const event = props.event || { }

        console.log('event: ',event)

        this.state = {
            submitted: false,
            form: {
                ...getFormInitialState(),
                ...this.extractStateFromEvent(event)
            }
        }
    }

    extractStateFromEvent = event => ({
        message: event.message || '',
        styledRichText: this.getStyledRichText(event)
    })

    getStyledRichText = event => event.extra && event.extra.styledRichText ? event.extra.styledRichText : ({
        blocks: (event.message || '').split("\n").map((m) => ({ data: {}, depth: 0, entityRanges: [], inlineStyleRanges: [], text: m, type: "unstyled"})), entityMap: {}
    })

    getNormalizedInputData = (styledRichText) => {
        const { form } = this.state
        const { event } = this.props

        return {
            uid: (event && event.uid) || undefined,
            __src: (event && event.__src) || undefined,
            extra: { ...event.extra, styledRichText},
            unique_key: (event && event.unique_key) || undefined,
            message: styledRichText.blocks.reduce((acc, cur) => acc + (acc ? "\n"  : '') + cur.text, ``),
            relatedEventTimestamp: (event && event.relatedEventTimestamp) || undefined
        }
    }

    submit = (styledRichText) => {
        return new Promise((resolve, reject) => {
            const data = this.getNormalizedInputData(styledRichText)
            const { form, submitted } = this.state
            const editing = !!data.uid

            if (!submitted) {
                this.setState({
                    submitted: true
                })
            }

            xhr
                .post(URL + SITOP_COMMENT_URL, data)
                .then(({ data }) => {
                    resolve({
                        data,
                        form,
                        initialState: getFormInitialState()
                    })

                    this.props.onHide(data, form, getFormInitialState(), editing)
                })
                .catch(e => console.error(e) || reject(e))
        })
    }

    setFormValue = (key: string, value: mixed, cb?: Function) => {
        this.setState(
            {
                form: {
                    ...this.state.form,
                    [key]: value
                }
            },
            cb
        )
    }

    componentDidMount () {
        if (_.isFunction(this.props.liftSubmitFn)) this.props.liftSubmitFn(this.submit)
    }

    render () {
        const { form, submitted } = this.state
        const { showActions, event, onHide } = this.props

        return (
            <ReportForm form={form} submitted={submitted} submit={this.submit} onHide={onHide} event={event} showActions={showActions}></ReportForm>
        )
    }

}

function ReportForm ({
    form,
    event,
    submitted,
    showActions,
    onHide,
    submit,
}) {
       const [formState, { raw }] = useFormState(form)

       return (
                   <div>
                       <Modal.Header>
                           <Modal.Title>{event && event.__src === 'observations' ? i18n('Recommendations / Observations') : event.__src === 'pendencies' ? i18n('Critical Pendencies') : event.title }</Modal.Title>
                       </Modal.Header>
                       <Modal.Body>
                           <label htmlFor="timeline-to-date-picker">{i18n('Message')}:</label>
                           <FieldRow textarea>
                           <InputContainer style={{backgroundColor: 'white', height: 150, overflowY: 'scroll' }}>
                               <StyledRichText
                                   initialValue={form.styledRichText}
                                   {...raw({
                                        name: 'styledRichText',
                                        validateOnBlur: true
                                   })}
                               />
                           </InputContainer>
                           </FieldRow>

                           {submitted && form.errors.get('message-empty') ? (
                               <div>
                                   <HelpBlock bsClass="text-danger">{i18n('This is a required field.')}</HelpBlock>
                               </div>
                           ) : null}
                       </Modal.Body>
                       <Modal.Footer>
                           {showActions === false ? null : (
                               <div className="timeline__form-actions">
                                   <SaveButton
                                       className="btn-lg btn-bold mr-5"
                                       disabled={(submitted && !!form.errors.size)}
                                       message={i18n('Note saved successfully')}
                                       showSavedAlert={form.saved}
                                       onClick={() => submit(formState.values.styledRichText)}
                                   />
                                   <span>{i18n('or')} </span>
                                   <a onClick={onHide} className="cancel">
                                       {' '}
                                       {i18n('cancel')}
                                   </a>
                               </div>
                           )}
                       </Modal.Footer>
                   </div>
               )
}

function getFormInitialState () {
    return {
        errors: new Map(),
        message: ''
    }
}
